import deepmerge from 'deepmerge';

import TR from '../../bluestone/TR';
import type { Colors } from '../../types';
import baseColors from './base/TR';
import deprecatedColors from './deprecated';
import derivedColors from './derived/TR';

const colors: Colors = {
  ...TR.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.primary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
